import React, { memo } from 'react';
import { NextSeo } from 'next-seo';
import { keywords } from 'next-seo.config';

import truncate from 'lodash/truncate';
import trim from 'lodash/trim';
import isEmpty from 'lodash/isEmpty';

import { HOST, isBrowser } from '@lib/helpers';
import { categoryHref } from '@helpers/route';
import CanonicalDetector from '@helpers/canonical-detector';

const Seo = ({ data }) => {
  const categoryName = isEmpty(data.get('metaTitle'))
    ? data.get('name')
    : data.get('metaTitle');

  const title = truncate(
    `${trim(categoryName).replace(/(\r\n|\n|\r)/g, '')} | ${keywords}`,
    { length: 60 }
  );
  const description = trim(data.get('metaDescription')).replace(
    /(\r\n|\n|\r)/g,
    ''
  );

  const canonical = `${HOST}${categoryHref(
    data.get('id'),
    data.get('urlKey')
  )}`;

  return (
    <>
      <NextSeo
        title={title}
        titleTemplate={`%s`}
        description={description}
        openGraph={{
          title,
          description,
        }}
        canonical={canonical}
      />
      {!!canonical && isBrowser && <CanonicalDetector url={canonical} />}
    </>
  );
};

export default memo(Seo);
